import { getToken } from '@vitl-services/services/auth';
import React, { createContext, useState } from 'react';
import { SIDEBAR_VIEWS } from '@vitl-services/constants/blog';
import { IGlobal } from '@vitl-services/interfaces/global';

export const GlobalContext = createContext<IGlobal>({} as IGlobal);

interface IProps {
  children: JSX.Element;
}

export const StoreProvider = ({ children }: IProps) => {
  const [isLoggedIn, setIsLoggedIn] = useState(getToken());
  const [sidebar, setSidebar] = useState<string>(SIDEBAR_VIEWS.empty);

  const globalContext: IGlobal = {
    sidebar,
    setSidebar,
    isLoggedIn,
    setIsLoggedIn,
  };

  return (
    <GlobalContext.Provider value={globalContext}>
      {children}
    </GlobalContext.Provider>
  );
};
